import React from "react";
import { MOCK_PRODUCTS } from "../../Helper/Cotizacion/mockProducts";

const ProductSelector = ({ value, onSelect }) => {
	return (
		<label>
			Producto del catálogo
			<select
				value={value || ""}
				onChange={(event) => onSelect(event.target.value)}
			>
				<option value="">Seleccionar o dejar vacío para manual</option>
				{MOCK_PRODUCTS.map((product) => (
					<option key={product.id} value={product.id}>
						{product.nombre}
					</option>
				))}
			</select>
		</label>
	);
};

export default ProductSelector;
